<template>
  <v-container :fluid="screen === 'start'">
    <v-row
      justify="center"
      align="center"
      class="stripe py-5"
      style="margin-top: 20vh;"
      v-if="screen === 'start'"
    >
      <v-form class="text-center" style="min-width: 400px;" v-model="valid">
        <v-text-field v-model="serverId" label="Server ID"></v-text-field>
        <v-text-field
          label="Your name"
          v-model="name"
          :rules="[rules.required, rules.min, rules.max]"
        >
          <template v-slot:append>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="randomName">mdi-autorenew</v-icon>
              </template>
              Random name
            </v-tooltip>
          </template>
        </v-text-field>
        <v-btn color="primary" :disabled="!valid" @click="joinServer">
          Join
        </v-btn>
      </v-form>
    </v-row>
    <v-row v-else-if="screen === 'lobby'">
      <v-col>
        <Lobby
          v-if="player !== null"
          v-on:start="start"
          v-on:joinTeam="joinTeam"
          v-on:beCodemaster="beCodemaster"
          :is-host="isHost"
          :player="player"
          :team-a="teamA"
          :team-b="teamB"
          class="mb-4"
        ></Lobby>
        <v-text-field readonly outlined label="Game link" v-model="gameLink">
          <template v-slot:append>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  v-clipboard:copy="gameLink"
                  style="cursor: pointer;"
                >
                  mdi-content-copy
                </v-icon>
              </template>
              Copy
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <Game
      v-if="connection !== null && connection.open && player !== null"
      :connection="connection"
      :player="player"
      :teamA="teamA"
      :teamB="teamB"
    ></Game>
  </v-container>
</template>

<style scoped>
.stripe {
  border: 10px solid #a4bcd4;
  border-left: 0;
  border-right: 0;
  background: #fcfafa;
}
</style>

<script>
import faker from 'faker';
import colors from '../utils/colors';
import CreatePeer from '../libs/createPeer';
import Lobby from '../components/Lobby';
import Game from '../components/Game';

export default {
  name: 'Client',
  props: {
    destPeerId: {
      type: String,
      required: true,
    },
    server: {
      type: Object,
      required: true,
    },
  },
  components: {
    Lobby,
    Game,
  },
  data() {
    return {
      colors: colors,
      serverId: this.destPeerId,
      name: '',
      screen: 'start',
      player: null,
      connection: null,
      teamA: [],
      teamB: [],
      rules: {
        required: (value) => !!value || 'Required',
        min: (value) => value.trim().length >= 3 || 'Min 3 characters',
        max: (value) => value.trim().length <= 25 || 'Max 25 characters',
      },
      valid: false,
    };
  },
  computed: {
    gameLink() {
      let resolve = this.$router.resolve({
        name: 'Client',
        params: { serverId: this.serverId },
      });
      return window.location.origin + resolve.href;
    },
    isHost() {
      return this.server.isServerOpen();
    },
  },
  methods: {
    start() {
      this.server.start();
    },
    joinTeam(team) {
      this.connection.send({ action: 'choseTeam', team: team });
    },
    beCodemaster() {
      this.connection.send({ action: 'beCodemaster' });
    },
    randomName() {
      this.name = faker.internet.userName();
    },
    joinServer() {
      if (!this.valid) {
        return;
      }

      const logger = console;
      const peer = CreatePeer();
      peer.on('open', () => {
        logger.info('Connecting to host ' + this.serverId + ' ...');
        this.connection = peer.connect(this.serverId, {
          reliable: true,
          metadata: { name: this.name },
        });
        this.connection.on('open', () => {
          logger.info('Connected to host ' + this.serverId);
          this.screen = 'lobby';

          this.connection.on('data', (data) => {
            switch (data.action) {
              case 'state':
                if (data.isStarted === true) {
                  this.screen = 'game';
                }
                this.player = data.player;
                this.teamA = data.teamA.player;
                this.teamB = data.teamB.player;
                this.colors.teamA = data.teamA.color;
                this.colors.teamB = data.teamB.color;
                break;

              case 'gameOver':
                var wonOrLost =
                  data.winner === this.player.team ? 'won' : 'lost';
                alert('Game Over! Your team ' + wonOrLost + '!');
                this.screen = 'lobby';
                break;

              case 'message':
                console.info(data.message);
                break;
            }
          });
          this.connection.on('close', () => {
            console.info('Connection closed');
            this.screen = 'start';
          });
        });
      });
      peer.on('error', (error) => {
        if (this.isHost) {
          this.$router.push({ name: 'Home' });
        }

        alert(error);
        this.serverId = '';
        this.screen = 'start';
      });
    },
  },
  beforeDestroy() {
    if (this.connection !== null) {
      this.connection.close();
    }
  },
};
</script>

<style scoped></style>
